// Coach-mode access for a trial day lives in localStorage so it survives
// reloads and hand-overs between coaches. My Portal, the Swish IQ tab and
// coach mode all run on the same origin, so any of them can open /coach.

const UNLOCK_KEY = 'swishiq.deviceUnlock';
const COACH_KEY = 'swishiq.recordingCoach';

function read(key) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function write(key, value) {
  try {
    if (value == null) localStorage.removeItem(key);
    else localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // storage blocked: coach mode will ask to unlock again
  }
}

// coachTokens: coachId -> token for coaches who've passed the SMS check on
// this unlock (a coach launching from My Portal starts verified).
export function saveUnlock({ deviceToken, subEventId, eventId, expiresAt, coach }) {
  const coachTokens = coach && coach.token ? { [coach.id]: coach.token } : {};
  write(UNLOCK_KEY, { deviceToken, subEventId, eventId, expiresAt, coachTokens });
  write(COACH_KEY, coach && coach.token ? { id: coach.id, name: coach.name, role: 'Coach', subEventId } : null);
}

export function getCoachToken(coachId) {
  const unlock = loadUnlock();
  return (unlock && unlock.coachTokens && unlock.coachTokens[coachId]) || null;
}

export function saveCoachToken(coachId, token) {
  const unlock = loadUnlock();
  if (!unlock) return;
  write(UNLOCK_KEY, { ...unlock, coachTokens: { ...(unlock.coachTokens || {}), [coachId]: token } });
}

export function forgetCoachToken(coachId) {
  const unlock = loadUnlock();
  if (!unlock || !unlock.coachTokens) return;
  const next = { ...unlock.coachTokens };
  delete next[coachId];
  write(UNLOCK_KEY, { ...unlock, coachTokens: next });
}

export function loadUnlock() {
  const unlock = read(UNLOCK_KEY);
  if (!unlock || !unlock.deviceToken) return null;
  if (unlock.expiresAt && new Date(unlock.expiresAt) <= new Date()) {
    clearUnlock();
    return null;
  }
  return unlock;
}

export function clearUnlock() {
  write(UNLOCK_KEY, null);
  write(COACH_KEY, null);
}

export function loadRecordingCoach() {
  return read(COACH_KEY);
}

export function saveRecordingCoach(coach) {
  write(COACH_KEY, coach);
}

// Call synchronously in the click handler, before any await, so the
// browser treats the new tab as user-initiated rather than a pop-up.
export function openBlankCoachTab() {
  try {
    return window.open('', '_blank');
  } catch {
    return null;
  }
}

// Opens coach mode in a new tab for the access the API just issued. The
// tab reads the same localStorage (same origin), so it starts straight in.
export function openCoachMode(unlock, tab) {
  saveUnlock(unlock);
  const url = `/coach/${unlock.subEventId}`;
  if (tab && !tab.closed) tab.location.href = url;
  else if (!window.open(url, '_blank')) window.location.assign(url);
}

let fontsRequested = false;
export function ensureSwishFonts() {
  if (fontsRequested || typeof document === 'undefined') return;
  fontsRequested = true;
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://fonts.googleapis.com/css2?family=Anton&family=Poppins:wght@400;500;600;700&display=swap';
  document.head.appendChild(link);
}
